
import { getMaxIndex } from '@/utils/index';

export default {
  name: 'CreateView', // 所有新建效果的view
  components: {},
  props: {
    bodyStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    // 更改背景颜色颜色
    backgroundColor: {
      type: String,
      default: '#F5F6F9' // rgba(0, 0, 0, 0.6) 黑色半透明
    },
    /** 展示内容的宽 */
    width: {
      type: String,
      default: '900px'
    },
    /** 展示内容的上下padding */
    padding: {
      type: String,
      default: '40px'
    }
  },
  data: function data() {
    return {
      zIndex: getMaxIndex(),
      loadingObj: null
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {},

  methods: {
    afterEnter: function afterEnter() {
      this.$emit('afterEnter');
    }
  }
};